import NewNavbar from "./NewNavbar";
import Footer from "./Footer";

export default function NewAboutUs() {
  return (
    <>
      <NewNavbar />

      <section className="py-20 bg-[#F8FAF6]">
        <div className="max-w-7xl mx-auto px-6">
          {/* Top Section */}
          <div className="grid md:grid-cols-2 gap-12 items-center">
            {/* Video */}
            <div className="flex justify-center">
              <video
                src="https://livestockify-assets.s3.ap-south-1.amazonaws.com/Videos/ABOUT+US.mp4"
                controls
                autoPlay
                muted
                loop
                playsInline
                className="w-full max-w-md rounded-xl shadow-md"
              />
            </div>

            {/* About Text */}
            <div className="text-left">
              <h2 className="text-2xl md:text-3xl font-bold text-[#6FAF1E]">
                About <span className="text-[#0F6D73]">Us</span>
              </h2>

              <p className="text-gray-600 font-regular mt-4 text-sm md:text-base leading-relaxed">
                Kuppismart delivers intelligent IoT-based monitoring solutions
                that transform aquaculture, poultry farming, water treatment,
                and environmental systems. By combining advanced sensors,
                connected devices, and AI-powered analytics, we enable real-time
                insights, early risk detection, and data-driven decisions that
                improve productivity, sustainability, and operational
                efficiency.
              </p>
            </div>
          </div>

          {/* Stats */}
          <div className="grid grid-cols-1 sm:grid-cols-3 text-center mt-16 gap-8">
            <div>
              <h3 className="text-6xl font-bold text-[#6FAF1E]">1000+</h3>
              <p className="mt-2 font-semibold md:text-2xl text-gray-800">
                Devices
              </p>
            </div>

            <div>
              <h3 className="text-6xl font-bold text-[#0F6D73]">25%</h3>
              <p className="mt-2 font-semibold md:text-2xl text-gray-800">
                Increase in Productivity
              </p>
            </div>

            <div>
              <h3 className="text-6xl font-bold text-[#6FAF1E]">35+</h3>
              <p className="mt-2 font-semibold md:text-2xl text-gray-800">
                Projects
              </p>
            </div>
          </div>

          {/* Founder Section */}
          <div className="mt-20">
            <h2 className="text-2xl md:text-3xl font-bold text-center">
              About <span className="text-[#6FAF1E]">Founder</span>
            </h2>

            <div className="grid md:grid-cols-2 gap-12 items-center mt-10">
              {/* Image */}
              <div className="flex justify-center">
                <img
                  src="http://res.cloudinary.com/dt8emxboh/image/upload/v1773740829/ehxmhnx5pshurqgwhrmn.png"
                  alt="Founder"
                  className="w-[260px] md:w-[320px] rounded-xl shadow-md"
                />
              </div>

              {/* Founder Info */}
              <div className="text-left">
                <h3 className="text-xl md:text-5xl font-extrabold text-[#6FAF1E]">
                  Akhil Reddy K
                </h3>

                <p className="text-gray-800 font-extrabold mt-1 text-sm md:text-2xl">
                  Founder and CEO of Kuppismart Solutions Pvt Ltd
                </p>

                <p className="text-[#5D5D5D]  mt-4 font-bold text-sm md:text-base leading-relaxed">
                  Inspired by his grandfather’s struggles in farming, Akhil
                  Reddy dreamed of making farming simpler and smarter. With his
                  deep understanding of farmers’ challenges and a passion for
                  technology, he founded Kuppismart Solutions Pvt Ltd
                  (Livestockify) to bridge the gap between agriculture and
                  innovation. His vision is simple yet powerful: to give every
                  farmer, big or small, access to smart tools that make farming
                  easier, healthier, and more profitable.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 bg-[#F8FAF6]">
        <div className="max-w-7xl mx-auto px-6">
          {/* Heading */}
          <h2 className="text-2xl md:text-3xl font-bold text-center">
            Recognised and <span className="text-[#6FAF1E]">Supported By</span>
          </h2>

          {/* Logos Grid */}
          <div className="mt-12 grid grid-cols-3 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-4 gap-16 items-center">
            {/* Logo Item */}
            <div className="flex justify-center">
              <img
                src="http://res.cloudinary.com/dt8emxboh/image/upload/v1773743687/dh6eww8wmczbh81aoqde.png"
                alt="logo"
                className="h-12 md:h-24 object-contain"
              />
            </div>

            <div className="flex justify-center">
              <img
                src="http://res.cloudinary.com/dt8emxboh/image/upload/v1773743740/ct6vhbjdgqegzhoc3sul.png"
                alt="logo"
                className="h-12 md:h-24 object-contain"
              />
            </div>

            <div className="flex justify-center">
              <img
                src="http://res.cloudinary.com/dt8emxboh/image/upload/v1773743782/edkogqbjyehy2s9scfwg.png"
                alt="logo"
                className="h-12 md:h-24 object-contain"
              />
            </div>

            <div className="flex justify-center">
              <img
                src="http://res.cloudinary.com/dt8emxboh/image/upload/v1773743821/bihhg8a3sr1sduh1ofku.png"
                alt="logo"
                className="h-12 md:h-24 object-contain"
              />
            </div>

            <div className="flex justify-center">
              <img
                src="http://res.cloudinary.com/dt8emxboh/image/upload/v1773746383/obwleln7b20dxnma2sqr.png"
                alt="logo"
                className="h-12 md:h-24 object-contain"
              />
            </div>

            <div className="flex justify-center">
              <img
                src="http://res.cloudinary.com/dt8emxboh/image/upload/v1773746439/dbhidz1o2lneih3nzzju.png"
                alt="logo"
                className="h-12 md:h-24 object-contain"
              />
            </div>

            <div className="flex justify-center">
              <img
                src="http://res.cloudinary.com/dt8emxboh/image/upload/v1773746484/eiy1swcilvs35cdknq6c.png"
                alt="logo"
                className="h-12 md:h-24 object-contain"
              />
            </div>

            <div className="flex justify-center">
              <img
                src="http://res.cloudinary.com/dt8emxboh/image/upload/v1773746529/w7lx0xym1q6m1rslbzvt.png"
                alt="logo"
                className="h-12 md:h-24 object-contain"
              />
            </div>

            <div className="flex justify-center">
              <img
                src="http://res.cloudinary.com/dt8emxboh/image/upload/v1773746760/tnt8imi575xstdowrpfa.png"
                alt="logo"
                className="h-12 md:h-24 object-contain"
              />
            </div>

            <div className="flex justify-center">
              <img
                src="http://res.cloudinary.com/dt8emxboh/image/upload/v1773746846/kkvndkmvfp6qqdt6dqhg.png"
                alt="logo"
                className="h-12 md:h-24 object-contain"
              />
            </div>

            <div className="flex justify-center">
              <img
                src="http://res.cloudinary.com/dt8emxboh/image/upload/v1773746888/oq8f2apkbryfnwf9qnxn.png"
                alt="logo"
                className="h-12 md:h-24 object-contain"
              />
            </div>

            <div className="flex justify-center">
              <img
                src="http://res.cloudinary.com/dt8emxboh/image/upload/v1773746931/u6yf17wl1car5ao2huwq.png"
                alt="logo"
                className="h-12 md:h-24 object-contain"
              />
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
}
